import { _ as t } from "../internals/export.js";
import { f as r } from "../internals/function-call.js";
import { i as o } from "../internals/is-object.js";
import { a as e } from "../internals/an-object.js";
import { i as s } from "../internals/is-data-descriptor.js";
import "../internals/object-get-own-property-descriptor.js";
import { o as i } from "../internals/object-get-prototype-of.js";
import { __exports as a } from "../../../_virtual/object-get-own-property-descriptor.js";
t({
  target: "Reflect",
  stat: !0
}, {
  get: function t(n, p) {
    var m,
      f,
      j = arguments.length < 3 ? n : arguments[2];
    return e(n) === j ? n[p] : (m = a.f(n, p)) ? s(m) ? m.value : void 0 === m.get ? void 0 : r(m.get, j) : o(f = i(n)) ? t(f, p, j) : void 0;
  }
});